import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import GuestCheckout from "../components/GuestCheckout";
import { CartProvider } from "../../cart/context/CartContext";
import BottomFooter from "../../../shared/layout/BottomFooter";
const GuestCheckoutPage = () => {

    return (
        <CartProvider>
        <ColorInit color={'bigmall'} />
        <ScrollToTop smooth color="#ef253c" />
        <Header />
        <div className="container container-lg">
        <GuestCheckout />
        </div>

        <Footer />
        <BottomFooter />
        </CartProvider>
    );
    };

export default GuestCheckoutPage;